module.exports = __webpack_public_path__ + "media/images/wines/tempranillo/bottle-bced6e272d3aec287056b9d0cd84411a.png";